<template>
	<div class="login-page">
		Not found
	</div>
</template>

<script>
	export default {
		data() {
			return {
				entity: {
					customer_id: 1,
					username: '',
					password: ''
				},
				error: null
			};
		},
		methods: {
			login() {
				//this.error = 'Der skete en fejl under login';

				this.error = null;

				var self = this;

				this.axios
					.post('/token/', this.entity)
					.then(function (r) {
						console.log(r);	
						
						self.$store.state.auth = r.data;

						self.$router.replace('/');

						self.axios
							.get('/me/')
							.then(function (r) {
								console.log(r);
								self.$store.commit('employee', r.data);
							});	

					}, function (err) {
						console.log('ERROR');
						console.log(err.response);
						var r = err.response;

						if (r.status == 422) {
							self.error = r.data;
						} else if (r.status == 401) {
							self.error = 'Brugeren blev ikke fundet';
						} else {
							self.error = 'Der opstod en systemfejl';
						}
					});	
			}
		}
	}
</script>

<style lang="scss" scoped>
	.login-page {

		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 1fr 400px;

		/*background: url('/images/login-bg.jpg') no-repeat left center;*/
		background-size: cover;

		& > .logo {
			background-color: rgba(0, 0, 0, 0.5);
		}

		& > .login {
			background-color: white;

			& > .content {
				padding: 150px 55px 0 55px;
				position: relative;
				height: 100%;

				& > h1 {
					font-size: 24px;
				}

				& > p {
					margin-top: 20px;
					font-size: 12px;
					color: rgb(150, 150, 150);

					&.error {
						color: #f7223f;
					}
				}

				& > .form {
					margin-top: 30px;

					& > input {
						margin-top: 20px;

						border: 1px solid rgb(209, 209, 209);
						border-radius: 3px;
						font-size: 12px;
						font-weight: 100;
						width: 100%;
						height: 30px;
						line-height: 30px;
						padding: 0 10px 0 10px;

						&::placeholder {
							color: rgb(168, 168, 168);
						}
					}
				}

				& > .button {
					margin-top: 20px;
					width: 100%;
					text-align: center;
					border-radius: 3px;
				}

				& > .moovr {
					position: absolute;
					left: 0;
					bottom: 0;
					width: 290px;
					left: 55px;
					bottom: 55px;
					text-align: center;

					& > .logo {
						width: 60%;
						margin-bottom: 20px;
					}

					& > .copyright {
						font-size: 12px;
					}
				}
			}
		}
	}
</style>